import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArchive } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
import { bytesToString } from "@/utils/utils";
export default /*#__PURE__*/ _defineComponent({
    __name: 'RecoverableItemSizeTooltip',
    props: {
        data: null,
        isRecoverable: { type: Boolean },
        isArchived: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        library.add(faArchive);
        const label = computed(() => { var _a, _b; return (_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : "No data"; });
        const prettySize = computed(() => { var _a, _b; return bytesToString((_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 0); });
        return { __sfc: true, props, label, prettySize, FontAwesomeIcon };
    }
});
